import createSubmit from '../../Form/createSubmitButton.jsx'
import { name } from './OfferAnswerDenialForm.jsx'
export default createSubmit(name)